
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1152:994)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#F20808"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33.055 14.47l-2.47 2.47-2.469-2.47-1.646 1.646 2.47 2.47-2.47 2.47 1.646 1.646 2.47-2.47 2.47 2.47 1.646-1.647-2.47-2.47 2.47-2.469-1.647-1.646zM22.945 29h-6.723v2.5h3.056V34h2.444v-2.5h1.223c.81 0 1.587-.33 2.16-.915a3.16 3.16 0 00.895-2.21c0-.829-.322-1.623-.895-2.21a3.021 3.021 0 00-2.16-.915h-4.89a.604.604 0 01-.432-.183.632.632 0 010-.884.604.604 0 01.432-.183h6.723v-2.5h-3.056V19h-2.444v2.5h-1.223c-.81 0-1.587.33-2.16.915a3.161 3.161 0 00-.895 2.21c0 .829.322 1.624.895 2.21.573.586 1.35.915 2.16.915h4.89c.162 0 .317.066.432.183a.632.632 0 010 .884.604.604 0 01-.432.183z","fill":"#fff"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1152:994","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1152:994"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1152:994","result":"shape"}})])])])
          )
        }
      }
    